












import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { ciStarFull } from '~/icons/source/regular/star-full'
import { ciStarEmpty } from '~/icons/source/regular/star-empty'
import { ciStarHalf } from '~/icons/source/regular/star-half'

export default defineComponent({
  props: {
    iconStyle: {
      type: String as PropType<'empty' | 'half' | 'full'>,
      default: 'empty'
    },
    colorClass: {
      type: String,
      default: 'tw-text-orange-500'
    },
    size: {
      type: Number,
      default: 20
    },
    static: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const icon = computed(() => {
      switch (props.iconStyle) {
        case 'empty':
          return ciStarEmpty
        case 'half':
          return ciStarHalf
        case 'full':
          return ciStarFull
      }
    })

    return {
      icon
    }
  }
})
